<div c-select-workflowconfig-view class="child sub-view">
    <div class="content solo">
        <section class="child">
            <div c-toggle="viewVisible" c-toggle-options="{type: 'fade'}">
                <h1 ng-bind-html="title"></h1>
                <div c-select-list toggle="0" items="workflows" selected-item="selectedWorkflow" validation="validation"></div>
                <div class="warning" ng-if="!workflows.length && newIssueMode" ng-bind-html="'workflowConfigs.newIssue'|translate"></div>
                <div class="warning" ng-if="!workflows.length && !newIssueMode" ng-bind-html="noWorkflowAvailable"></div>
            </div>
        </section>
    </div>
</div>
